import React from 'react';
import { Box, Typography } from '@mui/material';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';

function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return '';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

function getCallLabel(direction, status) {
  const isOutbound = direction === 'BUSINESS_INITIATED';
  if (status === 'MISSED') {
    return isOutbound ? 'Unanswered call' : 'Missed voice call';
  }
  if (status === 'REJECTED') return 'Declined voice call';
  if (status === 'FAILED') return 'Call failed';
  if (status === 'TERMINATED_BY_BUSINESS') return 'Voice call';
  if (status === 'COMPLETED') return 'Voice call';
  return 'Voice call';
}

export function getCallPreviewText(contextStr) {
  if (!contextStr) return 'Voice call';
  try {
    const ctx = typeof contextStr === 'string' ? JSON.parse(contextStr) : contextStr;
    const label = getCallLabel(ctx.direction, ctx.status);
    const dur = formatDuration(ctx.duration);
    return dur ? `${label} · ${dur}` : label;
  } catch {
    return 'Voice call';
  }
}

function getIcon(direction, status) {
  const isMissed = ['MISSED', 'REJECTED', 'FAILED'].includes(status);
  const color = isMissed ? '#e53935' : '#43a047';

  if (isMissed) {
    return <PhoneMissedIcon sx={{ fontSize: 20, color, transform: direction === 'BUSINESS_INITIATED' ? 'scaleX(-1)' : 'none' }} />;
  }
  if (direction === 'BUSINESS_INITIATED') {
    return <CallMadeIcon sx={{ fontSize: 20, color }} />;
  }
  return <CallReceivedIcon sx={{ fontSize: 20, color }} />;
}

export default function CallMessageBubble({ callMeta }) {
  if (!callMeta || typeof callMeta !== 'object') return null;

  const { direction, status, duration } = callMeta;
  const label = getCallLabel(direction, status);
  const dur = formatDuration(duration);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 160 }}>
      {getIcon(direction, status)}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
          {label}
        </Typography>
        {dur && (
          <Typography variant="caption" color="text.secondary">
            {dur}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
